import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, CheckCircle, Loader2 } from "lucide-react";
import { ticketsAPI } from "../api";
import { useLang } from "../context/LangContext";

const TicketsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t, lang } = useLang();
  const [tickets, setTickets] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // Backenddagi haqiqiy soniga qarab, sahifalab (dinamik) yuklaymiz —
  // scroll-trigger'ga bog'liq emas, shuning uchun ekran balandligidan
  // qat'i nazar barcha biletlar to'liq yuklanadi.
  const loadAllTickets = useCallback(async () => {
    setLoading(true);
    try {
      let page = 1;
      let all: any[] = [];
      const limit = 40;
      while (true) {
        const r = await ticketsAPI.getAll(page, limit);
        const d = r.data || {};
        const incoming: any[] = d.data || d.tickets || (Array.isArray(d) ? d : []);
        if (!incoming || incoming.length === 0) break;

        all = [...all, ...incoming];

        const meta = d.meta || {};
        const total = Number(meta.total ?? NaN);
        const totalPages =
          meta.totalPages != null ? Number(meta.totalPages)
          : Number.isFinite(total) ? Math.ceil(total / limit)
          : incoming.length < limit ? page // limitdan kam qaytdi — oxirgi sahifa
          : page + 1;

        if (page >= totalPages || incoming.length < limit) break;
        page += 1;
      }
      setTickets(all);
    } catch (err) {
      console.error(t("ticketsLoadError"), err);
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    loadAllTickets();
  }, [lang, loadAllTickets]);

  return (
    <div className="min-h-screen bg-[#0a0e1a]">
      <header
        className="fixed top-0 left-0 right-0 z-50 bg-[#0a0e1a]/95 backdrop-blur-md border-b border-[#1f2d45] h-[calc(52px+env(safe-area-inset-top))] pt-[env(safe-area-inset-top)]">
        <div className="max-w-[520px] lg:max-w-[1040px] mx-auto px-4 h-full flex items-center gap-3">
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm font-semibold">
            <ArrowLeft size={18} /> {t("back")}
          </button>
          <h1 className="text-white font-bold text-base">{t("tickets")}</h1>
        </div>
      </header>

      <main className="max-w-[520px] lg:max-w-[1040px] mx-auto px-4 pt-[68px] pb-10">
        <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 gap-2.5">
          {tickets.map((ticket, i) => {
            const pct = Number(ticket.userStats?.bestScore || 0);
            const isDone = pct >= 90;

            return (
              <button
                key={`${ticket.id}-${i}`}
                onClick={() => navigate(`/quiz/ticket/${ticket.id}`)}
                className={`flex flex-col items-center justify-center p-4 rounded-2xl border transition-all duration-200 ${isDone ? "bg-green-500/10 border-green-500/30 text-green-500 shadow-lg shadow-green-500/5" : "bg-[#111827] border-[#1f2d45] text-white hover:border-blue-500/50"}`}>
                <span className="text-xl font-black mb-1">{ticket.id}</span>
                <span className="text-[9px] font-bold text-gray-500 uppercase tracking-tighter mb-2">
                  {t("questionsCount", { n: ticket.count || 20 })}
                </span>

                {isDone ?
                  <CheckCircle size={14} className="text-green-500" />
                : <div className="w-full h-1 bg-gray-800 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-orange-500 transition-all"
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                }
              </button>
            );
          })}
        </div>

        {loading && (
          <div className="flex justify-center py-8">
            <Loader2 className="animate-spin text-blue-500" size={28} />
          </div>
        )}

      </main>
    </div>
  );
};

export default TicketsPage;
